export default {
    SET_SYSTEM_SCALE_RATE: 'SET_SYSTEM_SCALE_RATE',
};
